import { createAsyncThunk } from '@reduxjs/toolkit';
import { setMessage } from '../../../redux/slice';
import * as api from '../api';

export const doGetAllDeliveryAreas = createAsyncThunk(
  'deliveryAreas/doGetAllDeliveryAreas',
  async (params, thunkAPI) => {
    try {
      const { response, error } = await api.getAllDeliveryAreas(params);
      return error ? thunkAPI.rejectWithValue(error) : response;
    } catch (e) {
      thunkAPI.rejectWithValue(e);
      throw e;
    }
  },
);

export const doCreateDeliveryAreas = createAsyncThunk(
  'deliveryAreas/doCreateDeliveryAreas',
  async (params, thunkAPI) => {
    try {
      const { response, error } = await api.createDeliveryArea(params);
      if (!error) thunkAPI.dispatch(setMessage('Your action has been completed successfully'));
      return error ? thunkAPI.rejectWithValue(error) : response;
    } catch (e) {
      thunkAPI.rejectWithValue(e);
      throw e;
    }
  },
);

export const doUpdateDeliveryArea = createAsyncThunk('deliveryAreas/doUpdateDeliveryArea', async (params, thunkAPI) => {
  try {
    const { response, error } = await api.updateDeliveryArea(params);
    if (!error) thunkAPI.dispatch(setMessage('Your action has been completed successfully'));
    return error ? thunkAPI.rejectWithValue(error) : response;
  } catch (e) {
    thunkAPI.rejectWithValue(e);
    throw e;
  }
});

export const doDeleteDeliveryAreas = createAsyncThunk(
  'deliveryAreas/doDeleteDeliveryAreas',
  async (params, thunkAPI) => {
    try {
      const { response, error } = await api.deleteDeliveryArea(params);
      return error ? thunkAPI.rejectWithValue(error) : response;
    } catch (e) {
      thunkAPI.rejectWithValue(e);
      throw e;
    }
  },
);
